import { withInstall } from "../utils";
import _Checkbox from "./Checkbox";
const Checkbox = withInstall(_Checkbox);
var stdin_default = Checkbox;
export {
  Checkbox,
  stdin_default as default
};
